import React from "react";
import { Table  } from 'antd';
import Card from "components/card";
import { connect } from "react-redux";
import { NumberFormatter } from "../../../../utils/index";

const SalaryDeductionHistory = ({ recordData, requesting, ...props }) => {
  	const columns = [
		{
	        title: `Payroll Cut-Off`,
	        dataIndex: 'payrun',
	        key: 'payrun',
	        width: '70%',
	        render:(payrun) => <span>{payrun?.payroll?.pay_date_from + ' to ' + payrun?.payroll?.pay_date_to}</span> 
	    },
	    {
	        title: <div className="text-right">Deducted Amount</div>,
	        dataIndex: 'ppd_amount',
	        key: 'ppd_amount',
	        width: '30%',
	        render:(ppd_amount) => <div className="text-right">{NumberFormatter(ppd_amount)}</div>
	    },
    ];

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<h2 className="font-bold text-[18px] py-2 px-4">Deductions from Payroll</h2>
	      		<Table
		        	dataSource={recordData?.payroll_payrun_deductions} 
		        	columns={columns} 
		            rowKey={(record) => record.ppd_id}  
					pagination={false}	
	        	/>
				<div className="font-bold text-right p-2 pr-4">Balance: {NumberFormatter(recordData?.balance)}</div>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordData: state.salaryDeduction.salaryDeductionDetails?.data,
  	requesting: state.salaryDeduction.salaryDeductionDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryDeductionHistory);